import { useMemo } from 'react';

import { ITEMS_TYPES } from 'hb-react/shared/apps/Events/constants/itemsTypes';
import { useEventContext } from 'hb-react/shared/apps/Events/contexts/EventContext';
import { useRegistrationFlowContext } from 'hb-react/shared/apps/Events/contexts/RegistrationFlowContext';
import { getAddonsForTicket } from 'hb-react/shared/apps/Events/utils/getAddonsForTicket';
import { getTicketInformation } from 'hb-react/shared/apps/Events/utils/getTicketInformation';

export const useTransformShoppingCard = () => {
  const { event } = useEventContext();
  const { valuesStep1, valuesStep2 } = useRegistrationFlowContext();

  const tickets = useMemo(() => {
    const getAddons = getAddonsForTicket(
      valuesStep2?.network_events_booking?.attendees_attributes,
    );

    return (valuesStep1?.tickets || [])
      .filter(({ quantity }) => quantity > 0)
      .map(({ id, quantity }) => ({
        ...getTicketInformation({ tickets: event.tickets }, id),
        type: ITEMS_TYPES.TICKET,
        quantity: Number(quantity),
        addons: getAddons(id),
      }));
  }, [event, valuesStep1, valuesStep2]);

  const [addons, donations] = useMemo(
    () => [
      (valuesStep2?.network_events_booking?.addons_attributes || [])
        .filter(({ quantity }) => Number(quantity) > 0)
        .map((item) => ({
          ...item,
          type: ITEMS_TYPES.STANDALONE_ADDON,
        })),
      (valuesStep2?.network_events_booking?.donations_attributes || [])
        .filter(({ amount }) => Number(amount) > 0)
        .map((item) => ({
          ...item,
          price: Number(item.amount),
          type: ITEMS_TYPES.DONATION,
        })),
    ],
    [valuesStep2],
  );

  return { tickets, addons, donations };
};
